import {
  CircleCheckBig,
  Clock,
  CircleX,
  TrendingUp,
  IndianRupee,
} from "lucide-react";

const statsData = [
  {
    icon: IndianRupee,
    value: "₹3.0L",
    label: "Total Collected",
    iconBg: "bg-primary/10",
    iconColor: "text-primary",
    cardBg: "bg-gradient-to-br from-primary/5 to-primary/10",
    borderColor: "border-primary/20",
    valueColor: "text-secondary",
  },
  {
    icon: CircleCheckBig,
    value: "5",
    label: "Completed",
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    borderColor: "border-border/60",
    valueColor: "text-secondary",
  },
  {
    icon: Clock,
    value: "2",
    label: "Pending",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
    borderColor: "border-border/60",
  },
  {
    icon: CircleX,
    value: "1",
    label: "Failed",
    iconBg: "bg-red-100",
    iconColor: "text-red-600",
    borderColor: "border-border/60",
  },
  {
    icon: TrendingUp,
    value: "+24%",
    label: "vs Last Month",
    iconBg: "bg-green-100",
    cardBg: "bg-gradient-to-br from-green-50 to-green-100/50",
    iconColor: "text-green-600",
    borderColor: "border-green-200",
    valueColor: "text-green-600",
  },
];

const PaymentManagementSummaryCards = () => {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
      {statsData.map(stat => (
        <div
          key={stat.label}
          className={`rounded-2xl border bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md ${stat.cardBg} ${stat.borderColor}`}
        >
          <div className="p-4">
            <div className="flex items-center gap-3">
              <div className={`rounded-xl p-2.5 ${stat.iconBg}`}>
                <stat.icon className={`h-5 w-5 ${stat.iconColor}`} />
              </div>

              <div>
                <p className={`text-2xl font-bold ${stat.valueColor}`}>
                  {stat.value}
                </p>
                <p className={`text-xs text-muted-foreground`}>{stat.label}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default PaymentManagementSummaryCards;

// {/* Total Collected */}
// <div className="rounded-2xl border bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
//   <div className="p-4">
//     <div className="flex items-center gap-3">
//       <div className="p-2.5 rounded-xl bg-primary/10">
//         <IndianRupee className="w-5 h-5 text-primary" />
//       </div>
//       <div>
//         <p className="text-2xl font-bold text-secondary">₹3.0L</p>
//         <p className="text-xs text-muted-foreground">Total Collected</p>
//       </div>
//     </div>
//   </div>
// </div>

// Completed
// <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md">
//   <div className="p-4">
//     <div className="flex items-center gap-3">
//       <div className="p-2.5 rounded-xl bg-green-100">
//         <CircleCheckBig className="w-5 h-5 text-green-600" />
//       </div>
//       <div>
//         <p className="text-2xl font-bold text-secondary">5</p>
//         <p className="text-xs text-muted-foreground">Completed</p>
//       </div>
//     </div>
//   </div>
// </div>

// {/* Pending */}
// <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md">
//   <div className="p-4">
//     <div className="flex items-center gap-3">
//       <div className="p-2.5 rounded-xl bg-amber-100">
//         <Clock className="w-5 h-5 text-amber-600" />
//       </div>
//       <div>
//         <p className="text-2xl font-bold text-secondary">2</p>
//         <p className="text-xs text-muted-foreground">Pending</p>
//       </div>
//     </div>
//   </div>
// </div>

// {/* Failed */}
// <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md">
//   <div className="p-4">
//     <div className="flex items-center gap-3">
//       <div className="p-2.5 rounded-xl bg-red-100">
//         <CircleX className="w-5 h-5 text-red-600" />
//       </div>
//       <div>
//         <p className="text-2xl font-bold text-secondary">1</p>
//         <p className="text-xs text-muted-foreground">Failed</p>
//       </div>
//     </div>
//   </div>
// </div>

// {/* Trending / Growth */}
// <div className="rounded-2xl border bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md bg-gradient-to-br from-green-50 to-green-100/50 border-green-200">
//   <div className="p-4">
//     <div className="flex items-center gap-3">
//       <div className="p-2.5 rounded-xl bg-green-100">
//         <TrendingUp className="w-5 h-5 text-green-600" />
//       </div>
//       <div>
//         <p className="text-2xl font-bold text-green-600">+24%</p>
//         <p className="text-xs text-muted-foreground">vs Last Month</p>
//       </div>
//     </div>
//   </div>
// </div>
